// PricingPage.tsx
import React from 'react';
import { Grid, Container } from '@mui/material';
import Typography from '../components/Typography';
import PricingPlanCard from '../components/PricingplanCard';
import Box from '@mui/material/Box';


const PricingPage: React.FC = () => {
    const plans = [
        {
            title: 'Trial (Invited Only)',
            price: '¥500',
            features: ['✔︎ リスニング強化の一部機能'],
            buttonText: 'Get Trial',
        },
        {
            title: 'Professional',
            price: '¥990',
            features: ['✔︎ Trialの全機能に加え...', '✔︎ リスニング強化の全機能', '✔︎ クラスルームの統計情報表示及び管理機能'],
            buttonText: 'Get Premium',
        },
        {
            title: 'Premium',
            price: '¥1,200',
            features: ['✔︎ Professionalの全機能に加え...', '✔︎ スピーキング強化の全機能'],
            buttonText: 'Get Ultimate',
        },
    ];

    return (
        <Container sx={{ py: 8 }}>
            <Box sx={{ mt: 7, mb: 12 }}>
                <Typography variant="h3" gutterBottom align="center" marked="center" sx={{ color: "#0d47a1" }}>
                    Pricing Plans
                </Typography>
            </Box>
            <Grid container spacing={4} justifyContent="center">
                {plans.map((plan) => (
                    <Grid item key={plan.title} xs={12} sm={6} md={4}>
                        <PricingPlanCard
                            title={plan.title}
                            price={plan.price}
                            features={plan.features}
                            buttonText={plan.buttonText}
                        />
                    </Grid>
                ))}
            </Grid>
            <Box sx={{ mt: 7, mb: 12 }}>
                <Typography variant="h5" gutterBottom align="center">

                </Typography>
            </Box>
        </Container>
    );
};

export default PricingPage;
